// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page container */
.system-monitoring-page {
  min-height: 100vh;
  background: #f1f5f9;
  padding: 28px 32px;
  box-sizing: border-box;
}

/* Page header */
.system-monitoring-header {
  margin-bottom: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  row-gap: 12px;
}

.system-monitoring-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}

.system-monitoring-filter-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #475569;
}

.system-monitoring-filter-select {
  min-width: 220px;
  padding: 8px 12px;
  font-size: 0.875rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
}

.system-monitoring-refresh-btn {
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  background: #2563eb;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.system-monitoring-refresh-btn:hover {
  background: #1d4ed8;
}

.system-monitoring-refresh-status {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 20px;
  padding: 10px 14px;
  background: #edf2f7;
  border-radius: 8px;
  font-size: 13px;
  color: #4a5568;
}

.system-monitoring-refresh-status-item {
  white-space: nowrap;
}

.system-monitoring-title {
  margin: 0;
  font-size: 1.625rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.025em;
  line-height: 1.25;
}

.system-monitoring-last-update {
  font-size: 0.8125rem;
  color: #64748b;
  font-weight: 500;
}

.system-monitoring-status {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 0.875rem;
  color: #64748b;
}

.system-monitoring-status .status-badge {
  color: #059669;
  font-weight: 600;
}

.system-monitoring-status .status-sep {
  color: #cbd5e1;
  -webkit-user-select: none;
          user-select: none;
}

.system-monitoring-status .status-time {
  color: #475569;
}

/* Card wrapper */
.system-monitoring-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

/* Card tile header */
.system-monitoring-card-header {
  padding: 18px 24px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.system-monitoring-card-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: -0.01em;
}

/* Loading state */
.system-monitoring-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 48px 24px;
  font-size: 0.9375rem;
  color: #64748b;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #e2e8f0;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: system-monitoring-spin 0.7s linear infinite;
}

@keyframes system-monitoring-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Error state */
.system-monitoring-error {
  padding: 24px 24px;
  font-size: 0.9375rem;
  color: #b91c1c;
  background: #fef2f2;
  border-bottom: 1px solid #fecaca;
}

/* Table scroll wrapper for horizontal overflow on small screens */
.system-monitoring-table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Table */
.system-monitoring-table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.system-monitoring-table thead {
  position: relative;
}

.system-monitoring-table thead tr {
  background: #1e40af;
  color: #fff;
}

.system-monitoring-table th {
  padding: 14px 24px;
  text-align: left;
  font-weight: 600;
  font-size: 0.8125rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  vertical-align: middle;
  white-space: nowrap;
  border: none;
}

/* Column widths – header and body use same padding (24px) for alignment */
.system-monitoring-table th.col-time,
.system-monitoring-table td.col-time {
  width: 1%;
  padding-left: 24px;
  padding-right: 24px;
}

.system-monitoring-table th.col-app,
.system-monitoring-table td.col-app {
  min-width: 12rem;
  padding-left: 24px;
  padding-right: 24px;
}

.system-monitoring-table th.col-status,
.system-monitoring-table td.col-status {
  width: 1%;
  padding-left: 24px;
  padding-right: 24px;
}

.system-monitoring-table th.col-details,
.system-monitoring-table td.col-details {
  min-width: 14rem;
  padding-left: 24px;
  padding-right: 24px;
}

.system-monitoring-table tbody tr {
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.15s ease;
}

.system-monitoring-table tbody tr:last-child {
  border-bottom: none;
}

.system-monitoring-table tbody tr:hover {
  background: #f8fafc;
}

.system-monitoring-table td {
  padding: 14px 24px;
  text-align: left;
  color: #334155;
  vertical-align: middle;
  word-break: break-word;
  font-size: 0.875rem;
}

.system-monitoring-table tbody td.col-time {
  color: #475569;
  white-space: nowrap;
}

.system-monitoring-table tbody td.col-app {
  font-weight: 500;
  color: #1e293b;
}

.system-monitoring-table .event-status {
  font-weight: 600;
  display: inline-block;
}

.system-monitoring-table .event-status-stopped {
  color: #dc2626;
}

.system-monitoring-table tbody td.col-details {
  color: #475569;
}

/* Empty state */
.system-monitoring-empty {
  text-align: center;
  color: #94a3b8;
  padding: 48px 24px;
  font-size: 0.9375rem;
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .system-monitoring-page {
  background: var(--app-bg);
}
[data-theme="dark"] .system-monitoring-filter-label {
  color: var(--text-muted);
}
[data-theme="dark"] .system-monitoring-filter-select {
  border-color: var(--border);
  background: var(--surface);
  color: var(--text);
}
[data-theme="dark"] .system-monitoring-refresh-status {
  background: var(--surface-2);
  color: var(--text-muted);
}
[data-theme="dark"] .system-monitoring-title {
  color: var(--text);
}
[data-theme="dark"] .system-monitoring-last-update,
[data-theme="dark"] .system-monitoring-status,
[data-theme="dark"] .system-monitoring-loading {
  color: var(--text-muted);
}
[data-theme="dark"] .system-monitoring-card {
  background: var(--surface);
  border-color: var(--border);
}
[data-theme="dark"] .system-monitoring-card-header {
  background: var(--surface-2);
  border-bottom-color: var(--border);
}
[data-theme="dark"] .system-monitoring-card-title {
  color: var(--text);
}
[data-theme="dark"] .system-monitoring-table tbody tr {
  border-bottom-color: var(--border);
}
[data-theme="dark"] .system-monitoring-table tbody tr:hover {
  background: var(--surface-hover);
}
[data-theme="dark"] .system-monitoring-table td {
  color: var(--text-muted);
}
[data-theme="dark"] .system-monitoring-table tbody td.col-app {
  color: var(--text);
}
[data-theme="dark"] .system-monitoring-table tbody td.col-time,
[data-theme="dark"] .system-monitoring-table tbody td.col-details {
  color: var(--text-muted);
}

/* Mobile — desktop layout above unchanged */
@media (max-width: 768px) {
  .system-monitoring-page {
    padding: 12px;
    min-height: auto;
  }

  .system-monitoring-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .system-monitoring-title {
    font-size: 1.25rem;
  }

  .system-monitoring-filters {
    width: 100%;
  }

  .system-monitoring-filter-label {
    flex: 1 1 100%;
  }

  .system-monitoring-filter-select {
    min-width: 0;
    width: 100%;
  }

  .system-monitoring-refresh-btn {
    width: 100%;
  }

  .system-monitoring-refresh-status {
    flex-direction: column;
    gap: 8px;
  }

  .system-monitoring-refresh-status-item {
    white-space: normal;
  }

  .system-monitoring-card-header {
    padding: 14px 16px;
  }

  .system-monitoring-table th,
  .system-monitoring-table td {
    padding: 12px 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/system-monitoring/index.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA,0EAA0E;AAC1E;;EAEE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":["/* Page container */\n.system-monitoring-page {\n  min-height: 100vh;\n  background: #f1f5f9;\n  padding: 28px 32px;\n  box-sizing: border-box;\n}\n\n/* Page header */\n.system-monitoring-header {\n  margin-bottom: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  row-gap: 12px;\n}\n\n.system-monitoring-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px;\n}\n\n.system-monitoring-filter-label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #475569;\n}\n\n.system-monitoring-filter-select {\n  min-width: 220px;\n  padding: 8px 12px;\n  font-size: 0.875rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n}\n\n.system-monitoring-refresh-btn {\n  padding: 8px 16px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #fff;\n  background: #2563eb;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.system-monitoring-refresh-btn:hover {\n  background: #1d4ed8;\n}\n\n.system-monitoring-refresh-status {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  margin-bottom: 20px;\n  padding: 10px 14px;\n  background: #edf2f7;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #4a5568;\n}\n\n.system-monitoring-refresh-status-item {\n  white-space: nowrap;\n}\n\n.system-monitoring-title {\n  margin: 0;\n  font-size: 1.625rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.025em;\n  line-height: 1.25;\n}\n\n.system-monitoring-last-update {\n  font-size: 0.8125rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.system-monitoring-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.875rem;\n  color: #64748b;\n}\n\n.system-monitoring-status .status-badge {\n  color: #059669;\n  font-weight: 600;\n}\n\n.system-monitoring-status .status-sep {\n  color: #cbd5e1;\n  user-select: none;\n}\n\n.system-monitoring-status .status-time {\n  color: #475569;\n}\n\n/* Card wrapper */\n.system-monitoring-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n}\n\n/* Card tile header */\n.system-monitoring-card-header {\n  padding: 18px 24px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.system-monitoring-card-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e293b;\n  letter-spacing: -0.01em;\n}\n\n/* Loading state */\n.system-monitoring-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 48px 24px;\n  font-size: 0.9375rem;\n  color: #64748b;\n}\n\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #e2e8f0;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: system-monitoring-spin 0.7s linear infinite;\n}\n\n@keyframes system-monitoring-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Error state */\n.system-monitoring-error {\n  padding: 24px 24px;\n  font-size: 0.9375rem;\n  color: #b91c1c;\n  background: #fef2f2;\n  border-bottom: 1px solid #fecaca;\n}\n\n/* Table scroll wrapper for horizontal overflow on small screens */\n.system-monitoring-table-scroll {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Table */\n.system-monitoring-table {\n  width: 100%;\n  min-width: 640px;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.system-monitoring-table thead {\n  position: relative;\n}\n\n.system-monitoring-table thead tr {\n  background: #1e40af;\n  color: #fff;\n}\n\n.system-monitoring-table th {\n  padding: 14px 24px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.8125rem;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  vertical-align: middle;\n  white-space: nowrap;\n  border: none;\n}\n\n/* Column widths – header and body use same padding (24px) for alignment */\n.system-monitoring-table th.col-time,\n.system-monitoring-table td.col-time {\n  width: 1%;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.system-monitoring-table th.col-app,\n.system-monitoring-table td.col-app {\n  min-width: 12rem;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.system-monitoring-table th.col-status,\n.system-monitoring-table td.col-status {\n  width: 1%;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.system-monitoring-table th.col-details,\n.system-monitoring-table td.col-details {\n  min-width: 14rem;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.system-monitoring-table tbody tr {\n  border-bottom: 1px solid #e2e8f0;\n  transition: background-color 0.15s ease;\n}\n\n.system-monitoring-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.system-monitoring-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.system-monitoring-table td {\n  padding: 14px 24px;\n  text-align: left;\n  color: #334155;\n  vertical-align: middle;\n  word-break: break-word;\n  font-size: 0.875rem;\n}\n\n.system-monitoring-table tbody td.col-time {\n  color: #475569;\n  white-space: nowrap;\n}\n\n.system-monitoring-table tbody td.col-app {\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.system-monitoring-table .event-status {\n  font-weight: 600;\n  display: inline-block;\n}\n\n.system-monitoring-table .event-status-stopped {\n  color: #dc2626;\n}\n\n.system-monitoring-table tbody td.col-details {\n  color: #475569;\n}\n\n/* Empty state */\n.system-monitoring-empty {\n  text-align: center;\n  color: #94a3b8;\n  padding: 48px 24px;\n  font-size: 0.9375rem;\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .system-monitoring-page {\n  background: var(--app-bg);\n}\n[data-theme=\"dark\"] .system-monitoring-filter-label {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .system-monitoring-filter-select {\n  border-color: var(--border);\n  background: var(--surface);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .system-monitoring-refresh-status {\n  background: var(--surface-2);\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .system-monitoring-title {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .system-monitoring-last-update,\n[data-theme=\"dark\"] .system-monitoring-status,\n[data-theme=\"dark\"] .system-monitoring-loading {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .system-monitoring-card {\n  background: var(--surface);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .system-monitoring-card-header {\n  background: var(--surface-2);\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .system-monitoring-card-title {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .system-monitoring-table tbody tr {\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .system-monitoring-table tbody tr:hover {\n  background: var(--surface-hover);\n}\n[data-theme=\"dark\"] .system-monitoring-table td {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .system-monitoring-table tbody td.col-app {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .system-monitoring-table tbody td.col-time,\n[data-theme=\"dark\"] .system-monitoring-table tbody td.col-details {\n  color: var(--text-muted);\n}\n\n/* Mobile — desktop layout above unchanged */\n@media (max-width: 768px) {\n  .system-monitoring-page {\n    padding: 12px;\n    min-height: auto;\n  }\n\n  .system-monitoring-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .system-monitoring-title {\n    font-size: 1.25rem;\n  }\n\n  .system-monitoring-filters {\n    width: 100%;\n  }\n\n  .system-monitoring-filter-label {\n    flex: 1 1 100%;\n  }\n\n  .system-monitoring-filter-select {\n    min-width: 0;\n    width: 100%;\n  }\n\n  .system-monitoring-refresh-btn {\n    width: 100%;\n  }\n\n  .system-monitoring-refresh-status {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .system-monitoring-refresh-status-item {\n    white-space: normal;\n  }\n\n  .system-monitoring-card-header {\n    padding: 14px 16px;\n  }\n\n  .system-monitoring-table th,\n  .system-monitoring-table td {\n    padding: 12px 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
